var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./InclusionCaseStudies.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4d2ce4b7\",\"hasScoped\":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./InclusionCaseStudies.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/landings/InclusionCaseStudies.vue
// module id = 1479
// module chunks = 0